import * as React from 'react';
import { Product } from '~/Api/Product';
import { SiMaxPrice } from '~/Api/User/ProductGroup/SiMaxPrice';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		siMaxPrice: SiMaxPrice | null;
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ siMaxPrice, id, children }) => {
	const product = React.useMemo(
		() => siMaxPrice?.products.find((candidate) => candidate.product.id === id)?.product ?? null,
		[siMaxPrice, id]
	);
	return <>{children(product)}</>;
};

ProductProvider.displayName = 'SiMaxPrice.ProductProvider';
